"use strict";

angular.module("app.pages.blog", []);